import * as React from 'react';
import { IRadioOptionProps } from './radio-option-props';
import { FormControlLabel } from '../../form-control-label';
import { Radio } from '../radio/radio';
import './radio-option.scss';

type RadioOptionFunctionComponent = (<TEnumValue extends string>(props: IRadioOptionProps<TEnumValue>) => JSX.Element) & React.FunctionComponent<IRadioOptionProps<any>>;

export const RadioOption: RadioOptionFunctionComponent = <TEnumValue extends string>({
  children,
  control = <Radio />,
  disabled,
  label,
  value,
  style,
}: IRadioOptionProps<TEnumValue>) => (
  <FormControlLabel control={control!} classes={{ label: 'radio-option__label' }} disabled={disabled} label={label} value={value} style={style} />
);
